import script from "./xcare-type-tag.vue?vue&type=script&lang=ts&setup=true"
export * from "./xcare-type-tag.vue?vue&type=script&lang=ts&setup=true"

import "./xcare-type-tag.vue?vue&type=style&index=0&id=8d97f532&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8d97f532"]])

export default __exports__